<main class="main">
    <div class=" bg-white p-0">
        <div id="spinner" class="show bg-white-transparent position-fixed translate-middle w-100 vh-100 top-50 start-50 d-flex align-items-center justify-content-center">
            <div class="spinner-grow text-primary" style="width: 3rem; height: 3rem;" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
        <div class=" position-relative p-0">
            <nav class="navbar navbar-expand-lg navbar-light px-4 px-lg-5 py-3 py-lg-4">
                <a href="" class="navbar-brand p-0">
                    <h1 class="m-0"><i class="fa fa-search me-2"></i>Geovy<span class="fs-5">Pe</span></h1>
                </a>
                <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarCollapse">
                    <span class="fa fa-bars"></span>
                </button>
                <div class="collapse navbar-collapse" id="navbarCollapse">
                    <div class="navbar-nav ms-auto py-0">
                    </div>
                    <button (click)="showModalLogin()" class="btn btn-secondary text-light rounded-pill py-2 px-4 ms-3">Login</button>
                </div>
            </nav>

            <div class=" py-5 bg-primary hero-header mb-5">
                <div class="container my-5 py-5 px-lg-5">
                    <div class="row g-5 py-5">
                        <div class="col-lg-6 text-center text-lg-start">
                            <h1 class="text-white mb-4 animated zoomIn">Con GeovyPe podrás ver tus dispositivos cuando lo necesites</h1>
                            <p class="text-white pb-3 animated zoomIn">Podrás disponer de muchas funcionalidades que <strong>GeovyPe</strong> pone a tu disposición</p>
                            <button (click)="showModalLogin()" style="width: 200px;" class="btn btn-light py-sm-3 px-sm-5 rounded-pill me-3 animated slideInLeft">Acceder</button>
                            <!-- <a href="" class="btn btn-light py-sm-3 px-sm-5 rounded-pill me-3 animated slideInLeft">Descarga para Android</a>
                            <a href="" class="btn btn-outline-light py-sm-3 px-sm-5 rounded-pill animated slideInRight">IOS Proximamente</a> -->
                        </div>
                        <div class="col-lg-6 text-center text-lg-start">
                            <img class="img-fluid" src="geovy-plugins/img/hero.png" alt="">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal fade" id="searchModal" tabindex="-1">
            <div class="modal-dialog modal-fullscreen">
                <div class="modal-content" style="background: rgba(29, 29, 39, 0.7);">
                    <div class="modal-header border-0">
                        <button type="button" class="btn bg-white btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body d-flex align-items-center justify-content-center">
                        <div class="input-group" style="max-width: 600px;">
                            <input type="text" class="form-control bg-transparent border-light p-3" placeholder="Type search keyword">
                            <button class="btn btn-light px-4"><i class="bi bi-search"></i></button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <a class="btn btn-lg btn-primary btn-lg-square back-to-top pt-2" ><i class="bi bi-arrow-up"></i></a>
    </div>    
</main>  